import axios from "axios";
//自定义axios
export default {
  install: async function(Vue, configPath) {
    Vue.prototype.userApi = {
      //获取验证码图片
      async getCodeImageBase64() {
        let time = new Date();
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/captchabase64" + "?" + time.getTime(),
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //用户登录
      async userLogin(name, pass, code) {
        let time = new Date();
        var res = await Vue.prototype.EduUserAxios({
          method: "post",
          url: "/login",
          data: {
            loginName: name,
            loginPwd: pass,
            captchaCode: code,
            timeOutMinute: 1440, //1天
          },
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },

      //用户登出
      async logout() {
        //console.log('dfsfd')
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/logout",
        });
        //console.log("logout:")
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //修改密码
      async updatePassword(oldpassword, newpassword) {
        var data = {
          OldPassWord: oldpassword,
          NewPassWord: newpassword,
        };
        //console.log(data);
        var res = await Vue.prototype.EduUserAxios({
          method: "put",
          url: "/user/pwd",
          data: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //管理员分页获取平台成员列表
      async getPlatformList(
        unId = "",
        searchName = "",
        pageIndex = 1,
        pageSize = 10
      ) {
        var data = {
          UnitId: unId,
          Name: searchName,
          PageNumber: pageIndex,
          PageSize: pageSize,
        };
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/platform",
          params: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //单位成员查询
      async getEmps(searchName, pageIndex = 1, pageSize = 10) {
        var data = {
          Platform: true,
          Name: searchName,
          PageNumber: pageIndex,
          PageSize: pageSize,
        };
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/emps",
          params: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //创建新用户
      async createUser(name, phone, unId, description, orderNum) {
        const data = {
          Name: name,
          Phone: phone,
          UnitId: unId,
          OfficeName: description,
          OrderNum: orderNum,
        };
        var res = await Vue.prototype.EduUserAxios({
          method: "post",
          url: "/platform/" + unId,
          data: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //修改用户信息
      async updateUser(uid, name, phone, unId, description, orderNum) {
        const patch = [
          { op: "replace", path: "/Name", value: name },
          { op: "replace", path: "/Phone", value: phone },
          { op: "replace", path: "/UnitId", value: unId },
          { op: "replace", path: "/OfficeName", value: description },
          { op: "replace", path: "/OrderNum", value: orderNum },
        ];
        var res = await Vue.prototype.EduUserAxios({
          method: "patch",
          url: "/platform/" + uid,
          data: patch,
          headers: {
            "Content-Type": "application/json_patch+json", // 默认 JSON 格式
          },
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //修改用户在用户系统角色
      async updateUserRoles(uid, roles) {
        var res = await Vue.prototype.EduUserAxios({
          method: "put",
          url: "/role/set/" + uid,
          data: {
            Roles: roles,
          },
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      async resetPassword(uid) {
        var res = await Vue.prototype.EduUserAxios({
          method: "put",
          url: "/platform/repwd/" + uid,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      async movetoUser(uid) {
        var res = await Vue.prototype.EduUserAxios({
          method: "put",
          url: "/platform/out/" + uid,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //将移除用户移入指定单位
      async moveInUser(uid, unId) {
        var res = await Vue.prototype.EduUserAxios({
          method: "put",
          url: "/platform/in/" + uid,
          data: {
            UnitId: unId,
          },
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //删除移出用户
      async deleteUser(uid) {
        var res = await Vue.prototype.EduUserAxios({
          method: "delete",
          url: "/platform/" + uid,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //分页读取移除成员列表
      async getMoveUsers(searchName, pageIndex = 1, pageSize = 10) {
        var data = {
          Name: searchName,
          PageNumber: pageIndex,
          PageSize: pageSize,
        };
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/platform/moves",
          params: data,
        });

        return new Promise((resolve) => {
          resolve(res);
        });
      },

      //获取全部单位
      async getUnitAll() {
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/unit",
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },

      // 分页查询单位列表
      async getUnits(name = "", pageIndex = 1, pageSize = 10) {
        const data = {
          Name: name,
          PageNumber: pageIndex,
          PageSize: pageSize,
        };
        var res = await Vue.prototype.EduUserAxios({
          method: "get",
          url: "/unit/list",
          params: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      getUnitName(units, unId) {
        var name = "";
        for (var i = 0; i < units.length; i++) {
          if (units[i].id == unId) {
            name = units[i].name;
            break;
          }
        }
        return name;
      },
      //创建单位信息
      async createUnit(name, description, orderNum) {
        const data = {
          Name: name,
          Descript: description,
          OrderNum: orderNum,
        };
        // console.log(data);
        var res = await Vue.prototype.EduUserAxios({
          method: "post",
          url: "/unit",
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      //修改单位信息
      async updateUnit(unId, name, description, orderNum) {
        const data = {
          Name: name,
          Descript: description,
          OrderNum: orderNum,
        };
        // console.log(data);
        var res = await Vue.prototype.EduUserAxios({
          method: "put",
          url: "/unit/" + unId,
          data: data,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
      async deleteUnit(unId) {
        var res = await Vue.prototype.EduUserAxios({
          method: "delete",
          url: "/unit/" + unId,
        });
        return new Promise((resolve) => {
          resolve(res);
        });
      },
    }; //user api end
  }, //install end
};
